// enum which contains the survey states
const SurveyStatus = Object.freeze({
  PUBLISHED: 'PUBLISHED',
  DRAFT: 'DRAFT'
});

export default SurveyStatus;
